import styled from "styled-components";

export const StyledActions = styled.div
  `
    display:flex;
    cursor:pointer;

  .dot{
    width:3px;
    height:3px;
    border-radius:50%;
    background:#050A30;
    margin:3px 4px 0 0;
  }

  
  
`